import './EmailConfirmation.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Card } from '../../../../../design/card/card/S_Cards';
import { ResendStatus } from '../../containers/ConfirmEmailContainer';
import { ResendEmail } from './ResendEmail';

interface IProps {
  resendStatus: ResendStatus;
  onResendActivationEmailClick: () => Promise<void>;
}

export const ResendConfirmationEmail = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <div className='account-activation'>
      <S_Card>
        <div className='header'>{t('verification_link_title')}</div>
        <div className='content'>{t('verify_your_email')}</div>
        <ResendEmail
          onResendActivationEmailClick={props.onResendActivationEmailClick}
          resendStatus={props.resendStatus}
        />
      </S_Card>
    </div>
  );
});
